module.exports = __webpack_public_path__ + "assets/img/img188.4e530bab.png";